import { PRODUCTS_ACCESS } from "@/helpers/permissionsConstant";

export default [
  {
    title: "Sliders",
    route: "admin-sliders",
    icon: "ImageIcon",
    gate: PRODUCTS_ACCESS,
  },
];
